var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSideNo5 = function SvgSideNo5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sideNO_5_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sideNO_5_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DFBF86",
    d: "M2 21.906a1 1 0 0 0 1.496.868l8.482-4.847a1 1 0 0 1 1.03.023l7.458 4.71A1 1 0 0 0 22 21.815V1.629a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.395 8.284q.705.09 1.373.322.667.233 1.192.675t.848 1.125.322 1.688q0 .975-.307 1.605-.308.63-.743.997-.435.368-.915.54t-.81.233q-.12.03-.36.052-.24.023-.547.038t-.63 0-.593-.075q-.12-.015-.36-.075t-.533-.165-.615-.263-.607-.367v-2.04q.105.165.308.352.202.188.465.36.262.173.57.33t.622.263q.12.045.315.082t.405.06.397.023.293-.015q.345-.045.585-.218.24-.172.383-.412.142-.24.202-.51t.06-.525q0-.285-.045-.593-.045-.307-.18-.592t-.39-.518-.69-.382q-.42-.15-.855-.21t-.855-.075-.817 0-.743.03V4.429h6.345v2.145H10.64v1.62q.51-.015.893.007.382.023.862.083"
  }))));
};
export default SvgSideNo5;